(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-related-products"] && !Shopify.designMode) return;
  try {
    
var initCartRelatedSwiper = function() {
  if (typeof Swiper === 'undefined') return;
  new Swiper('.cart-swiper-container', {
    slidesPerView: 2,
    spaceBetween: 15,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 25,
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', initCartRelatedSwiper);

document.addEventListener('shopify:section:load', function(event) {
  initCartRelatedSwiper();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var initRelatedSwiper = function() {
  if (typeof Swiper === 'undefined') return;
  new Swiper('.related-swiper-container', {
    slidesPerView: 2,
    spaceBetween: 15,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 25,
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', initRelatedSwiper);

document.addEventListener('shopify:section:load', function(event) {
  initRelatedSwiper();
});

  } catch(e) { console.error(e); }
})();
})();
